import { captureException } from '@/shared/utils/captureException';

import { RegistrationDialogueSeenSourceEvent } from './tracking/registrationDialogSeenSource';

export type Event = RegistrationDialogueSeenSourceEvent;

export const trackEvent = (event: Event) => {
  if (typeof window === 'undefined') {
    return;
  }

  if (window.dataLayer === undefined) {
    captureException(
      new Error('Unable to track the event. DataLayer not found'),
      {
        tags: { fingerprint: 'google_analytics' },
      }
    );
    return;
  }
  window.dataLayer.push(event);
};
